import {Dropdown, Loader} from "semantic-ui-react";
import styles from "../ProjectTeam.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ProjectMembersModel from "../../../../../../../models/responses/project-members.model";
import {PendingMembershipsModel} from "../../../../../../../models/pending-memberships.model";
import React from "react";
import {
    usePendingProjectMemberListSelector,
    useProjectMemberListSelector
} from "../../../../../../../store/selectors/team.selectors";


export default function TeamDropdown(props: {
    member: ProjectMembersModel | PendingMembershipsModel,
    onClick: any,
    icon: any,
    title: string,
    type: 'taskForce' | 'taskOwner'
}) {
    const projectMembersList = useProjectMemberListSelector();
    const pendingMembersList = usePendingProjectMemberListSelector();
    const {member, onClick, icon, title, type} = props;
    const [loading, setLoading] = React.useState(false);

    return (
        <Dropdown
            style={{width: '100%'}}
            className={styles.MemberItemOptionDropdown}
            scrolling
            disabled={loading || !(!member[`${type}ReassignedTo`])}
            trigger={
                <div className={styles.MemberItemOption}>
                    <FontAwesomeIcon icon={icon} className={styles.MemberIconWrap} />
                    <span>{title}</span>
                    {loading && <Loader active inline size='mini' className={styles.MemberItemOptionLoader} />}
                </div>}
            icon={null}
            options={[...projectMembersList, ...pendingMembersList]
                .filter((m: ProjectMembersModel | PendingMembershipsModel) => m.userEmail !== member.userEmail)
                .map((m: ProjectMembersModel | PendingMembershipsModel) => ({
                    key: m.userEmail,
                    text: m.userEmail,
                    value: m.userEmail,
                    onClick: () => {
                        setLoading(true);
                        onClick(m.userEmail).then(() => setLoading(false)).catch(() => setLoading(false));
                    },
                }))}
        />
    )
}